module.exports = __webpack_public_path__ + "img/chatNo.773b70c0.svg";